export default "__VITE_ASSET__B0PtiCVz__"